var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#32b744",
    d: "M 42.132812 99.785156 L 13.15625 74.386719 C 7.898438 69.753906 0.00390625 76.132812 3.511719 82.292969 L 30.523438 129.46875 C 34.839844 137.308594 46.304688 138.5 52.097656 131.625 L 53.003906 130.585938 L 148.097656 21.914062 C 149.957031 19.792969 150.007812 16.566406 148.097656 14.382812 C 146.019531 12.011719 142.414062 11.773438 140.046875 13.851562 Z M 42.132812 99.785156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.8c1929cbcdf62c04c769f3ae01d52693.svg";
export { ForwardRef as ReactComponent };